import Repository from './Repository'
import TokenService from '../helpers/token'

const baseURL  = `${Repository.defaults.baseURL}`

export default {
    async listProgramApi(attrs,params) {
        const response = await Repository.get(`${baseURL}/fg/list?obj=program${attrs}`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
}
